import { render, staticRenderFns } from "./table-prime-simple.vue?vue&type=template&id=3b83e72c"
import script from "./table-prime-simple.vue?vue&type=script&lang=js"
export * from "./table-prime-simple.vue?vue&type=script&lang=js"
import style0 from "./table-prime-simple.vue?vue&type=style&index=0&id=3b83e72c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports